import { styled } from '@mui/material';
import { ITheme } from 'theme/types';

const PREFIX = 'ImageContainer';

export const classes = {
  cropContainer: `${PREFIX}-cropContainer`,
  cropButton: `${PREFIX}-cropButton`,
  controls: `${PREFIX}-controls`,
  imageSrcContainer: `${PREFIX}-imageSrcContainer`,
  sliderContainer: `${PREFIX}-sliderContainer`,
  sliderLabel: `${PREFIX}-sliderLabel`,
  slider: `${PREFIX}-slider`,
  handlerIcons: `${PREFIX}-handlerIcons`,
  smallPortraitIcon: `${PREFIX}-smallPortraitIcon`,
  pointer: `${PREFIX}-pointer`,
  defaultHtmlColor: `${PREFIX}-defaultHtmlColor`,
};

export const Root = styled('div')(({ theme }) => ({
  [`& .${classes.cropContainer}`]: {
    position: 'relative',
    width: '18.75rem',
    height: '14.563rem',
    '& .reactEasyCrop_CropArea': {
      color: 'rgba(240, 240, 240, 0.65)',
    },
  },

  [`& .${classes.cropButton}`]: {
    flexShrink: 0,
  },

  [`& .${classes.controls}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '18.75rem',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },

  [`& .${classes.imageSrcContainer}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  [`& .${classes.sliderContainer}`]: {
    display: 'flex',
    flex: '1',
    alignItems: 'center',
  },

  [`& .${classes.sliderLabel}`]: {
    [theme.breakpoints.down('xs')]: {
      minWidth: 65,
    },
  },

  [`& .${classes.slider}`]: {
    padding: '22px 0px',
    color: (theme as ITheme).palette.primary[700],
    '& .MuiSlider-rail': {
      color: '#73F1F7',
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      margin: '5',
    },
  },

  [`& .${classes.handlerIcons}`]: {
    marginTop: '10px',
  },

  [`& .${classes.smallPortraitIcon}`]: {
    paddingTop: '0.15rem',
  },

  [`& .${classes.pointer}`]: {
    cursor: 'pointer',
  },

  [`& .${classes.defaultHtmlColor}`]: {
    color: (theme as ITheme).palette.primary[700],
  },
}));